// extracted by mini-css-extract-plugin
export var actionButton = "_im-t";
export var buttonContainer = "_im-0";
export var buttonContainer2 = "_im-1";
export var buttonSection = "_im-2";
export var details = "_im-3";
export var dropdownItem = "_im-5";
export var dropdownItemsContainer = "_im-4";
export var fileInput = "_im-r";
export var headerButton = "_im-6";
export var icon = "_im-7";
export var input = "_im-8";
export var macroListItem = "_im-9";
export var mainContent = "_im-a";
export var microText = "_im-b";
export var modal = "_im-w";
export var optionsButton = "_im-c";
export var paperclip = "_im-s";
export var pillContent = "_im-d";
export var preview = "_im-e";
export var preview2 = "_im-f";
export var quillEditor = "_im-q";
export var selectedMacro = "_im-g";
export var sidebar = "_im-h";
export var sidebarHeader = "_im-j";
export var sidebarList = "_im-i";
export var sidebarListItem = "_im-k";
export var sidebarSearch = "_im-l";
export var snoozeDurationWrapper = "_im-v";
export var statusPillContainer = "_im-m";
export var tagsContainer = "_im-n";
export var unselectedMacro = "_im-o";
export var variable = "_im-u";
export var wrapper = "_im-p";